export const publisherBanListSelector = (state) => {
    var _a, _b;
    return (_b = (_a = state.api) === null || _a === void 0 ? void 0 : _a.records) === null || _b === void 0 ? void 0 : _b.publisherBan;
};
